import styled from '@emotion/styled'
import { Container } from '@mui/material'
import React from 'react'

const Wrapper = styled.div`
    padding: 6% 0;
`

const SectionWrapper = ({children}) => {
  return (
    <Wrapper> <Container maxWidth="xl">{children} </Container></Wrapper>
  )
}

export default SectionWrapper